//
// Migration Processor for Autentikar to FaceTec migration
// Performs 3D Liveness + 3D-to-2D Match against pre-existing S3 enrollment image
//
import { Config } from "../../Config";
import { FaceTecSDK } from "../../../core-sdk/FaceTecSDK.js/FaceTecSDK";
// Mismo umbral que SessionRequestProcessor: blobs < 1KB son init/handshake,
// blobs ≥ 1KB son capturas reales (FaceMap o foto).
var SDK_CAPTURE_BLOB_THRESHOLD_BYTES = 1024;
var MigrationProcessor = /** @class */ (function () {
    function MigrationProcessor(demonstrationExternalDatabaseRefID, enrollmentImageBase64, onCompleteCallback) {
        var _this = this;
        this.requestCount = 0;
        this.captureCount = 0;
        //
        // Part 2: Handling the Result of the Migration Flow
        //
        this.onSessionRequest = function (requestBlob, requestCallback) {
            console.log('🔄 [Migration] Iniciando procesamiento de migración Autentikar');
            _this.requestCount++;
            var blobLength = (requestBlob === null || requestBlob === void 0 ? void 0 : requestBlob.length) || 0;
            var isCapture = blobLength >= SDK_CAPTURE_BLOB_THRESHOLD_BYTES;
            if (isCapture)
                _this.captureCount++;
            var isLikelyInternalRetry = isCapture && _this.captureCount > 1;
            var retryNumber = isLikelyInternalRetry ? _this.captureCount - 1 : 0;
            try {
                var enviarLog = window.enviarLog;
                if (typeof enviarLog === 'function') {
                    enviarLog('sdk_session_request_sent', {
                        level: 'info',
                        processor: 'migration',
                        triggerFlow: window.__currentTriggerFlow || '',
                        requestCount: _this.requestCount,
                        captureCount: _this.captureCount,
                        blobLength: blobLength,
                        blobKind: isCapture ? 'capture' : 'init',
                        isLikelyInternalRetry: isLikelyInternalRetry,
                        retryNumber: retryNumber
                    });
                }
            }
            catch (e) {
                console.warn('⚠️ [Log] No se pudo enviar sdk_session_request_sent (migration):', e);
            }
            if (window.updateStepperProgress) {
                window.updateStepperProgress(2);
            }
            // Inyectar sessionId del frontend como instanceId para correlacionar en backend
            var instanceId = window.__sessionId || '';
            // Create payload with migration-specific fields
            var migrationPayload = {
                requestBlob: requestBlob,
                externalDatabaseRefID: _this.demonstrationExternalDatabaseRefID,
                enrollmentImageBase64: _this.enrollmentImageBase64,
                isMigration: true,
                instanceId: instanceId
            };
            console.log('📋 [Migration] Payload preparado:', {
                externalDatabaseRefID: _this.demonstrationExternalDatabaseRefID,
                requestBlobLength: requestBlob.length,
                enrollmentImageBase64Length: _this.enrollmentImageBase64.length,
                isMigration: true,
                instanceId: instanceId
            });
            // Send request to middleware
            _this.sendMigrationRequest(migrationPayload, requestCallback);
        };
        this.sendMigrationRequest = function (payload, requestCallback) {
            var request = new XMLHttpRequest();
            // Extraer parámetros de validación desde la URL
            var urlParams = new URLSearchParams(window.location.search);
            var expectedDocumentType = urlParams.get('expectedDocumentType');
            var country = urlParams.get('country');
            // Construir endpoint
            var fullEndpoint = Config.YOUR_API_OR_FACETEC_TESTING_API_ENDPOINT + '/process-request';
            if (expectedDocumentType || country) {
                var queryParams = new URLSearchParams();
                if (expectedDocumentType)
                    queryParams.append('expectedDocumentType', expectedDocumentType);
                if (country)
                    queryParams.append('country', country);
                fullEndpoint += "?".concat(queryParams.toString());
            }
            console.log('🌐 [Migration] Enviando a:', fullEndpoint);
            request.open('POST', fullEndpoint);
            request.setRequestHeader("Content-Type", "application/json");
            request.setRequestHeader("X-Device-Key", Config.DeviceKeyIdentifier);
            request.setRequestHeader("X-Testing-API-Header", FaceTecSDK.getTestingAPIHeader());
            request.onload = function () {
                switch (request.status) {
                    case 200:
                        try {
                            console.log('✅ [Migration] Respuesta exitosa recibida');
                            var parsedResponse = JSON.parse(request.responseText);
                            var responseBlob = parsedResponse.responseBlob;
                            console.log('📥 [Migration] Procesando respuesta:', {
                                hasResponseBlob: !!responseBlob,
                                responseBlobLength: (responseBlob === null || responseBlob === void 0 ? void 0 : responseBlob.length) || 0,
                                hasValidation: !!parsedResponse.validation,
                                hasAutentikarFormat: !!parsedResponse.autentikarFormat
                            });
                            // Guardar validación si existe
                            if (parsedResponse.validation) {
                                console.log('🔍 [Migration] Validación recibida:', parsedResponse.validation);
                                window.faceTecValidationData = parsedResponse.validation;
                            }
                            // Guardar autentikarFormat si existe
                            if (parsedResponse.autentikarFormat) {
                                console.log('📦 [Migration] AutentikarFormat recibido:', parsedResponse.autentikarFormat);
                                window.faceTecAutentikarFormat = parsedResponse.autentikarFormat;
                            }
                            requestCallback.processResponse(responseBlob);
                        }
                        catch (e) {
                            console.error('❌ [Migration] Error al parsear respuesta:', e);
                            requestCallback.abortOnCatastrophicError();
                        }
                        break;
                    default:
                        console.error("\u274C [Migration] Error del servidor - Status: ".concat(request.status));
                        requestCallback.abortOnCatastrophicError();
                }
            };
            request.onerror = function (ev) {
                console.error('❌ [Migration] Error catastrófico de red:', ev);
                requestCallback.abortOnCatastrophicError();
            };
            request.upload.onprogress = function (ev) {
                var progress = Math.round((ev.loaded / ev.total) * 100);
                console.log("\uD83D\uDCCA [Migration] Progreso de upload: ".concat(progress, "%"));
                requestCallback.updateProgress(ev.loaded / ev.total);
            };
            console.log('📤 [Migration] Enviando payload de migración');
            request.send(JSON.stringify(payload));
        };
        // Session is completely done
        this.onFaceTecExit = function (faceTecSessionResult) {
            console.log('🏁 [Migration] Migración completada');
            console.log('📊 [Migration] Status:', faceTecSessionResult.status);
            console.log('📄 [Migration] Resultado completo:', faceTecSessionResult);
            var internalRetries = Math.max(0, _this.captureCount - 1);
            try {
                var enviarLog = window.enviarLog;
                if (typeof enviarLog === 'function') {
                    enviarLog('sdk_session_processor_exit', {
                        level: 'info',
                        processor: 'migration',
                        triggerFlow: window.__currentTriggerFlow || '',
                        status: faceTecSessionResult.status,
                        requestCount: _this.requestCount,
                        captureCount: _this.captureCount,
                        internalRetries: internalRetries,
                        hadInternalRetries: internalRetries > 0
                    });
                }
            }
            catch (e) {
                console.warn('⚠️ [Log] No se pudo enviar sdk_session_processor_exit (migration):', e);
            }
            _this.onCompleteCallback(faceTecSessionResult.status);
        };
        this.demonstrationExternalDatabaseRefID = demonstrationExternalDatabaseRefID;
        this.enrollmentImageBase64 = enrollmentImageBase64;
        this.onCompleteCallback = onCompleteCallback;
    }
    return MigrationProcessor;
}());
export { MigrationProcessor };
